export const SHOW_DIALOG = "showDialog";
export const LOAD_NOTES = "loadNotes";
export const LOAD_API_NOTES = "loadApiNotes";
export const LOAD_ALL_NOTES = "loadAllNotes";

export const SHOW_DATUM_NOTES = "showDatumNotes";

export const DELETE_SELECTION = "deleteSelection";

export const EDIT_SELECTION = "editSelection";

export const CREATE_SELECTION = "createSelection";

export const EXPORT_NOTES = "exportNotes";
